import { createContext, ReactNode, useContext } from "react";

import { useFilterTierLevel } from "./filter-tier-level.hook";

const FilterTierLevelContext = createContext(
  {} as ReturnType<typeof useFilterTierLevel>
);
export function useFilterTierLevelContext() {
  return useContext(FilterTierLevelContext);
}

interface FilterTierLevelProviderProps {
  children: ReactNode;
}
export function FilterTierLevelProvider({
  children,
}: FilterTierLevelProviderProps) {
  return (
    <FilterTierLevelContext.Provider value={useFilterTierLevel()}>
      {children}
    </FilterTierLevelContext.Provider>
  );
}